import { cachedHttp } from "./httpService";

const apiEndPoint = "/uploadbuckets/";

function getUploadBuckets() {
  return cachedHttp.get(apiEndPoint);
}

export default getUploadBuckets;
